/**
 * AtalhosRapidosWidget — Links curados para acoes frequentes.
 *
 * REF-31: cada atalho so aparece se o usuario tem acesso ao destino,
 * reusando o gate da sidebar (`podeVerRota` sobre o catalogo MODULES em
 * utils/modules.jsx — sem duplicar strings de permissao aqui). Quando
 * nenhum atalho passa no gate, `visivelPara` remove o card inteiro do
 * grid e do painel "Personalizar" (nao renderiza card vazio).
 *
 * Futuro: configurar quais atalhos cada usuario quer ver.
 */
import React from "react";
import { Link } from "react-router-dom";
import { FiClipboard, FiPackage, FiPlus, FiSmartphone } from "react-icons/fi";

import { useAuth } from "../../../context/AuthContext";
import { podeVerRota } from "../../../utils/modules";
import { CardBody, KpiSub } from "../styles";


export const meta = {
  id: "atalhos_rapidos",
  label: "Atalhos rapidos",
  descricao: "Acesso direto as ações frequentes do dia-a-dia.",
  categoria: "Sistema",
  permissoes: [],
  tamanho_default: "M",
  essencial: true,
};

export const fetchData = null;

// Destinos precisam existir no catalogo MODULES (rota fora do catalogo eh
// ocultada pelo gate). "Novo orçamento" aponta pro CRM: a criacao de
// orcamento parte do cockpit do lead (rota antiga /comercial/orcamentos/criar
// nao existe mais).
const ATALHOS = [
  { to: "/crm", label: "Novo orçamento", icon: <FiPlus size={16} /> },
  { to: "/pedidos", label: "Pedidos", icon: <FiClipboard size={16} /> },
  { to: "/producao", label: "Produção", icon: <FiPackage size={16} /> },
  { to: "/whatsapp/inbox", label: "WhatsApp", icon: <FiSmartphone size={16} /> },
];

function atalhosVisiveis(hasAllPermissions, isMaster) {
  return ATALHOS.filter((a) => podeVerRota(a.to, { hasAllPermissions, isMaster }));
}

/**
 * Visibilidade dinamica consumida por `filtrarPorPermissoes` (_catalogo.js):
 * sem nenhum atalho acessivel, o card some por completo.
 */
export function visivelPara(hasAllPermissions, isMaster) {
  return atalhosVisiveis(hasAllPermissions, isMaster).length > 0;
}

export function Widget() {
  const { hasAllPermissions, isMaster } = useAuth();
  const atalhos = atalhosVisiveis(hasAllPermissions, isMaster);

  // Defesa em profundidade: o catalogo ja filtra via `visivelPara`.
  if (atalhos.length === 0) return null;

  return (
    <CardBody>
      <KpiSub>Ações frequentes</KpiSub>
      <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 8, marginTop: 8 }}>
        {atalhos.map((a) => (
          <Link
            key={a.to}
            to={a.to}
            style={{
              display: "flex",
              alignItems: "center",
              gap: 8,
              padding: "10px 12px",
              background: "var(--accent-soft)",
              borderRadius: 6,
              textDecoration: "none",
              color: "inherit",
              fontSize: "0.85rem",
              fontWeight: 600,
            }}
          >
            {a.icon}
            <span>{a.label}</span>
          </Link>
        ))}
      </div>
    </CardBody>
  );
}
